import { create } from 'zustand';
import type { AppliedChange } from './apply-change';

type AppliedChanges = {
  /** What each applied change put back on Undo, by message and change. */
  applied: Record<string, AppliedChange>;
  setApplied: (changeKey: string, applied: AppliedChange | null) => void;
};

/**
 * The changes from the chat that are applied. The cards close with the chat,
 * so this is where they remember, until the page reloads, that they were
 * applied and how to undo it.
 */
export const useAppliedChanges = create<AppliedChanges>()((set) => ({
  applied: {},
  setApplied: (changeKey, applied) =>
    set((state) => {
      const next = { ...state.applied };
      if (applied) next[changeKey] = applied;
      else delete next[changeKey];
      return { applied: next };
    }),
}));
